import React, { FC } from "react";
import { 
  Facebook, 
  Youtube, 
  Linkedin, 
  Twitter, 
  Github,
  Instagram,
  Send // for telegram
} from "lucide-react";

export interface SocialType {
  name: string;
  icon: React.ElementType;
  href: string;
}

export interface SocialsListProps {
  className?: string;
  itemClass?: string;
}

const socialsDemo: SocialType[] = [
  { name: "Facebook", icon: Facebook, href: "https://www.facebook.com/innovatorsforge" },
  { name: "Youtube", icon: Youtube, href: "https://youtube.com/@innovatorsforge?si=j9eqc3TOzMgYvBex" },
  { name: "LinkedIn", icon: Linkedin, href: "https://www.linkedin.com/company/innovatorsforge/" },
  { name: "Instagram", icon: Instagram, href: "https://www.instagram.com/innovatorsforge" },
  { name: "Twitter", icon: Twitter, href: "https://www.x.com/InnovatorsForge/" },
];

const SocialsList: FC<SocialsListProps> = ({
  className = "",
  itemClass = "block w-6 h-6",
}) => {
  return (
    <nav
      className={`nc-SocialsList flex space-x-3 text-neutral-600 dark:text-neutral-300 ${className}`}
      data-nc-id="SocialsList"
      aria-label="iForge social links"
    >
      {socialsDemo.map((item, i) => (
        <a
          key={i}
          className={`${itemClass} flex items-center justify-center rounded-full transition-all duration-300 hover:text-[#ff6600] dark:hover:text-[#ff6600] hover:scale-110`}
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
          title={item.name}
          aria-label={`Visit iForge on ${item.name}`}
        >
          <item.icon className="w-full h-full stroke-[1.5]" />
        </a>
      ))}
    </nav>
  );
};

export default SocialsList;
